import { useQuery } from 'react-query';
import config from '../config';
import axios from 'axios';
import useSearchState from "./useSearch";

export const getCacheKeyForTransport = (address) => `transport_${encodeURIComponent(address?.lat)}_${encodeURIComponent(address?.lng)}`;

const useTransport = (location) => {
  const {searchState} = useSearchState()
  const savedSearchId = searchState?.savedSearchId
  const cacheKey = getCacheKeyForTransport(location);
  const currentCacheKey = ["transportData", cacheKey, savedSearchId];
  const enabled = Boolean(location?.lat && location?.lng) && (savedSearchId === null);

  return useQuery(
    //['transportData', location?.lat, location?.lng],
    currentCacheKey,
    async () => {
      if (!location?.lat || !location?.lng) {
        throw new Error('Missing location coordinates');
      }
      const lat = typeof location.lat === 'number' ? location.lat : parseFloat(location.lat);
      const lng = typeof location.lng === 'number' ? location.lng : parseFloat(location.lng);
      if (isNaN(lat) || isNaN(lng)) {
        throw new Error('Invalid location coordinates');
      }
      const response = await axios.get(`${config.apiUrl}/transport/google`, {
        params: { lat, lng },
      });
      const busLinks = response.data.bus_links || [];
      const transitLinks = response.data.transit_links || [];
      return {
        ...response.data,
        links: [...busLinks, ...transitLinks],
      };
    },
    {
      //enabled: Boolean(location?.lat && location?.lng),
      enabled,
      staleTime: 5 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );
};

export default useTransport;
